import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// Connects to data-controller="track-download"
export default class extends Controller {
  static values = {
    cheatsheetId: Number
  }

  async track() {
    await post("/track/download", {
      body: JSON.stringify({
        cheatsheet_id: this.cheatsheetIdValue
      })
    })
  }
}
